import {CreditCardScheme, PREFIX_LENGTH_BY_SCHEME, LAST_FOUR_LENGTH} from './types.ts';

export function stripDigits(input: string): string {
    return input.replace(/\D/g, '');
}

const SCHEME_GROUPS: Record<CreditCardScheme, readonly number[]> = {
    [CreditCardScheme.VISA]: [4, 4, 4, 4],
    [CreditCardScheme.MASTERCARD]: [4, 4, 4, 4],
    [CreditCardScheme.JCB]: [4, 4, 4, 4],
    [CreditCardScheme.AMEX]: [4, 6, 5],
    [CreditCardScheme.DINERS]: [4, 6, 4],
};

function groupsForScheme(scheme: CreditCardScheme): readonly number[] {
    return SCHEME_GROUPS[scheme];
}

function totalDigitsForScheme(scheme: CreditCardScheme): number {
    return groupsForScheme(scheme).reduce((sum, size) => sum + size, 0);
}

function groupDigits(scheme: CreditCardScheme, fullNumber: string): string[] {
    const groups = groupsForScheme(scheme);
    const result: string[] = [];
    let offset = 0;

    for (const size of groups) {
        result.push(fullNumber.slice(offset, offset + size));
        offset += size;
    }

    return result;
}

export function formatCardNumberFromParts(
    scheme: CreditCardScheme,
    prefix: string,
    suffix: string,
    maskChar = '*',
): string[] {
    const total = totalDigitsForScheme(scheme);
    const cleanPrefix = stripDigits(prefix).slice(0, PREFIX_LENGTH_BY_SCHEME[scheme]);
    const cleanSuffix = stripDigits(suffix).slice(0, LAST_FOUR_LENGTH);
    const maskedLength = Math.max(total - cleanPrefix.length - cleanSuffix.length, 0);
    const full = cleanPrefix + maskChar.repeat(maskedLength) + cleanSuffix;

    return groupDigits(scheme, full);
}
